import React, { FormEvent, useRef } from 'react'
import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { User } from '../../reducers/auth/usersReducer'

type ReportFormProps = {
    state: any
    handleInputChange: (e: any) => void
    handleDeleteReport: (report: any, sucursal: any) => void
    handleEditReport: (report: any) => void
    submit: (e: any) => void
    isEditing: boolean
    isRegistering: boolean
}

export default function BusinessDocumentsForm({ state, handleInputChange, handleDeleteReport, handleEditReport, submit, isEditing, isRegistering }: ReportFormProps) {
    const { t } = useTranslation()
    const documentInput = useRef(null)

    const columnsDocuments = [
        {
            name: t('documentTranslate.title'),
            cell: (report: any) =>
                <div className='cursor' onClick={() => handleEditReport(report)}>
                    {report.titulo}
                </div>,
            selector: (report: any) => report.titulo,
            sortable: true,
        }, {
            name: t('global.actions'),
            width: '100px',
            center: true,
            cell: (report: any) =>
                <>
                    <div className='cursor me-3' onClick={() => handleEditReport(report)}>
                        <i className='fas fa-pencil'></i>
                    </div>
                    <div className='cursor' onClick={() => handleDeleteReport(state?.sucursalId, report._id)}>
                        <i className='fas fa-trash'></i>
                    </div>
                </>,
            sortable: false,
        }
    ]
    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col md={6}>
                    <Row>
                        <Col xs={12} className="my-2">
                            <Form.Label>{t('documentTranslate.title')}</Form.Label>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='titulo'
                                value={state.titulo || ''}
                                onChange={handleInputChange}
                                required
                            />
                        </Col>
                        <Col xs={12}>
                            <Form.Label>{t('documentTranslate.iframe')}</Form.Label>
                            <Form.Control
                                as='textarea'
                                name='iframe'
                                value={state.iframe || ''}
                                style={{ height: '150px' }}
                                onChange={handleInputChange}
                                ref={documentInput}
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="my-2 d-flex justify-content-end">
                            <Button
                                variant="primary"
                                type="submit"
                            >
                                {isEditing ? t('documentTranslate.edit') : t('documentTranslate.add')}
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col md={6}>
                    {state?.informes?.length > 0
                        ?
                        <CustomDataTable
                            columns={columnsDocuments}
                            data={state?.informes}
                            exportable={false}
                            printable={false}
                            filter={false}
                        />
                        :
                        <h4 className='mt-4'>{t('documentTranslate.noDocuments')}</h4>
                    }
                </Col>
            </Row>
        </Form>
    )
}